import { render, staticRenderFns } from "./statusEdit.vue?vue&type=template&id=383b7142&"
import script from "./statusEdit.vue?vue&type=script&lang=js&"
export * from "./statusEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports